import styled from 'styled-components'
import { device } from 'src/theme/theme'
import { safeAreaTopPadding } from 'src/styles/safeArea'

export const MenuHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  ${safeAreaTopPadding};

  .logo {
    display: flex;
    margin-left: 1rem;
    align-items: center;
  }

  .backdrop {
    display: none;
    position: absolute;
    height: 100vh;
    width: 100%;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;
    background: ${({ theme }) => theme.colors.primaryBackgroundColor};
    transition: all 0.2s;
    opacity: 0;
    @media ${device.tablet} {
      visibility: hidden;
    }
  }
  .mobile {
    .backdrop {
      opacity: 0.3;
      z-index: 2;
      display: block;
    }
  }
`

export const Content = styled.div`
  display: flex;
`

export const Grid = styled.div`
  grid-area: menu;
  width: 100%;
  display: grid;
  gap: 0 1rem;
  grid-template-columns: 1fr 5fr 1fr;
  grid-template-areas: 'menu-hamburger button_home profile' 'actions actions actions';

  @media ${device.tablet} {
    grid-template-columns: auto 1.5fr 1.5fr 0.8fr;
    grid-template-areas: 'logo button_home actions profile';
    gap: 0 1rem;
    justify-content: flex-start;
  }
  @media ${device.laptop} {
    grid-template-columns: auto 284px 1.5fr 2fr 1fr;
    grid-template-areas: 'logo button_home space-column actions profile';
    gap: 0 1rem;
    justify-content: flex-start;
  }

  .button_home {
    grid-area: button_home;
    display: flex;
    align-items: center;
    justify-content: center;
    @media ${device.tablet} {
      justify-content: flex-start;
    }
  }

  .button-hamburger {
    display: flex;
    grid-area: menu-hamburger;
    align-items: center;
    align-self: center;
    padding: 0 0 0 1rem;
    font-size: 1.5rem;

    @media ${device.tablet} {
      display: none;
    }
  }

  .progress-bar-container {
    grid-area: progress_bar;
    justify-self: flex-start;
    align-self: center;
    width: 100%;
    padding-left: ${p => p.theme.spacing.huge};

    span {
      ${p => ({ ...p.theme.typography.primary.normal })};
      font-size: 10px;

      @media ${device.mobileL} {
        font-size: 12px;
      }
    }

    @media (max-width: 768px) {
      padding-left: 0;
    }
  }

  .button-actions {
    grid-area: actions;
    justify-self: flex-end;
    display: flex;
    width: 100%;
    height: 100%;

    button {
      flex: 1;
      ${({ theme }) => ({ ...theme.size.xs })};
      height: 100%;

      &:disabled {
        :hover {
          filter: none;
        }
      }

      div {
        width: 100%;
        height: 100%;
        padding: 1rem;
      }

      :hover {
        filter: brightness(96%);
      }

      @media (max-width: 768px) {
        &:first-child div {
          border-left: 0;
        }

        &:last-child div {
          border-right: 0;
        }
      }
    }
  }

  .img-container {
    grid-area: profile;
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0.5rem 0;

    @media (max-width: 768px) {
      padding-right: 1rem;
    }

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
`

export const LogoDesktop = styled.img`
  display: none;

  @media ${device.tablet} {
    grid-area: logo;
    width: 40px;
    height: auto;
    display: block;
    align-self: center;
  }
`
